import { toast } from 'react-toastify';
import { string } from 'yup';
import { APICore } from '../../helpers/api/apiCore';
//import http from '../../services/httpService';
const api = new APICore();

export const fetchBrands = async (suffixUrl: string, params: string = "") => {
  try {
    let url: string = "";
    if (suffixUrl === "/License/activeCode")
      url = `${suffixUrl}?uniqueCode=${params}`
    else {
      if (params != "")
        url = `${suffixUrl}/${params}`;
      else
        url = suffixUrl;
    }    

    const { data } = await api.get(url, null);

    return data.data
  }
  catch (e) {
    return { "message": e }
  };
}

export const fetchBrands2 = async (suffixUrl: string, params: string = "") => {
  try {
    let url: string = "";
    if (suffixUrl === "/License/activeCode")
      url = `${suffixUrl}?uniqueCode=${params}`
    else {
      if (params != "")
        url = `${suffixUrl}/${params}`;
      else
        url = suffixUrl;
    }    

    const { data } = await api.get(url, null);
if (data?.isSuccess) {
  return data.data
}
else {
  return { sanjabError: data }
}
  }
  catch (e) {
    return { sanjabError: {isSuccess: false,message: "خطایی رخ داده است",statusCode: "error"} }

  };
}

export const addBrand = async (suffixUrl: string, item: any) => {
  try {
    const { data } = await api.create(suffixUrl, item);    
    if (data.isSuccess) {
      if (suffixUrl.indexOf('/Cube') === -1 && suffixUrl.indexOf('/Reporter/dataSource') === -1) {
        toast(data.message != "" ? data.message : "عملیات با موفقیت انجام شد", { type: 'success', toastId: 'successId' })
      }
                  
      return data.data
    }
    else {
      return { sanjabError: data }
    }
  }
  catch (e) {
    toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' })
    return null;
  }
};


export const editBrand = async (suffixUrl: string, item: any, itemId: any = null) => {
  try {
    // let data: any = null;
    // if (itemId != null &&  suffixUrl != '/Chart')
    //   data = await api.update(`${suffixUrl}/${itemId}`, item);
    // else
    const { data } = await api.update(suffixUrl, item);

    if (data.isSuccess) {
      if (suffixUrl != "/Chart" && suffixUrl != "/ChartMenuPage/updateChartFromPage")
        toast(data.message != "" ? data.message : "عملیات با موفقیت انجام شد", { type: 'success', toastId: 'successId' });
      return data.data
    }
    else {
      if (suffixUrl != "/Chart") {
        if (suffixUrl != "/ChartMenuPage/updateChartFromPage")
          return { sanjabError: data }
        else {
          if (data.statusCode === "UnAuthorized")
            {}
          else
            toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' });
        }
      }
    }
    // return s_data.data
  }
  catch (e: any) {
    if (suffixUrl != "/Chart" && suffixUrl != "/ChartMenuPage/updateChartFromPage")
      toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' });
    return null;
  }
};

export const deleteBrand = async (suffixUrl: string, itemId: any) => {
  try {
   
    const data = await api.delete(`${suffixUrl}/${itemId}`)
    if (data?.data?.isSuccess) {
      toast(data.data.message != "" ? data.data.message : "حذف با موفقیت انجام شد", { type: 'success', toastId: 'successDeleteId' });
    }
    else {
      toast(data.data.message != "" ? data.data.message : "عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });
    }
  }
  catch (e) {
    toast("عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });
  }
};

export const deleteBrandWithItem = async (suffixUrl: string, itemData: any) => {
  try {
    const data = await api.deleteWithItem(`${suffixUrl}`,itemData)
    if (data?.data?.isSuccess) {
      toast(data.data.message != "" ? data.data.message : "حذف با موفقیت انجام شد", { type: 'success', toastId: 'successDeleteId' });
    }
    else {
      toast(data.data.message != "" ? data.data.message : "عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });
    }
  }
  catch (e) {
    toast("عملیات حذف انجام نشد", { type: 'error', toastId: 'errorDeleteId' });
  }
};

export const fetchFile = async (suffixUrl: string, params: string = "") => {
  try {
    let url: string = "";
    if (suffixUrl === "/License/activeCode")
      url = `${suffixUrl}?uniqueCode=${params}`
    else {
      if (params != "")
        url = `${suffixUrl}/${params}`;
      else
        url = suffixUrl;
    }
    const { data } = await api.getFile(url, null);
    return data
  }
  catch (e) {
    return { "message": e }
  };
}

export const fetchFileForm = async (suffixUrl: string, pdata: any) => {
  try {
    let url: string = "";



    url = suffixUrl;

    const data = await api.getFileForm(url, pdata);
    return data
  }
  catch (e) {
    return { "message": e }
  };
}

export const addFile = async (suffixUrl: string, item: any) => {
  try {
    const data: any = await api.createFile(suffixUrl, item);

    if (data) {
      //toast(data.message != "" ? data.message : "عملیات با موفقیت انجام شد", { type: 'success', toastId: 'successId' })      
      return data.data
    }
    else {
      return { sanjabError: data }
    }
  }
  catch (e) {
    toast("خطایی در سیستم رخ داد", { type: 'error', toastId: 'errorId' })
    return null;
  }
};